export const RESET_PASSWORD_API_ERROR = "RESET_PASSWORD_API_ERROR";
export const RENDER_RESET_PASSWORD_FORM = "RENDER_RESET_PASSWORD_FORM";
export const RENDER_ERROR_SCREEN = "RENDER_ERROR_SCREEN";
export const SHOW_LOADER = "SHOW_LOADER";
export const RENDER_CONGRATULATION_SCREEN = "RENDER_CONGRATULATION_SCREEN";
export const SET_RESET_PASSWORD_ERROR_MESSAGE = "SET_RESET_PASSWORD_ERROR_MESSAGE";
